import styled from "styled-components";

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   width: 500px;

   .webhook-section h4 {
      margin: 0 0 6px 0;
      color: #333;
      font-size: 16px;
      font-weight: 600;
   }

   .link-container {
      border: 1px solid #ddd;
      border-radius: 4px;
      padding: 8px;
      background: #f9f9f9;
      cursor: pointer;
      max-width: 100%;
      overflow: hidden;
   }

   .link-with-copy {
      display: flex;
      align-items: center;
      gap: 8px;
      min-width: 0;
   }

   .copy-icon {
      color: #666;
      font-size: 12px;
      flex-shrink: 0;
   }

   .copy-icon.copied {
      color: #10b981;
   }

   .link-text {
      font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
      font-size: 14px;
      color: #333;
      word-break: break-all;
      overflow-wrap: break-word;
      white-space: normal;
      min-width: 0;
      flex: 1;
   }

   .instructions-section {
      margin: 0 0 12px;
      overflow: auto;
      height: 165px;
   }

   .instructions-section h5 {
      margin: 0 0 8px 0;
      color: #333;
      font-size: 14px;
      font-weight: 600;
   }

   .steps-list {
      margin: 0;
      padding-left: 16px;
      font-size: 14px;
      line-height: 1.4;
   }

   .steps-list li {
      margin-bottom: 6px;
   }

   .steps-list li a {
      color: #0066cc;
      text-decoration: none;
   }

   .steps-list li a:hover {
      text-decoration: underline;
   }

   .external-link {
      color: #673AB7;
      text-decoration: none;
      font-size: 14px;
      display: inline-flex;
      align-items: center;
      gap: 4px;
      margin-top: 8px;
   }

   .external-link:hover {
      text-decoration: underline;
   }

   .script-section {
      padding-top: 16px;
      border-top: 1px solid #eee;
   }

   .script-section h5 {
      margin: 0 0 10px 0;
      color: #333;
      font-size: 14px;
      font-weight: 600;
   }

   .script-container {
      position: relative;
      background: linear-gradient(180deg, #1a1a2e 0%, #16213e 100%);
      border-radius: 10px;
      padding: 16px;
      padding-top: 45px;
      max-height: 200px;
      overflow-y: auto;
      border: 1px solid #2d3748;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
   }

   .script-container::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 32px;
      background: #2d3748;
      border-radius: 10px 10px 0 0;
      display: flex;
      align-items: center;
      padding-left: 12px;
   }

   .script-container::after {
      content: '● ● ●';
      position: absolute;
      top: 8px;
      left: 12px;
      font-size: 10px;
      letter-spacing: 4px;
      color: #667eea;
   }

   .script-container::-webkit-scrollbar {
      width: 8px;
   }

   .script-container::-webkit-scrollbar-track {
      background: #1a1a2e;
      border-radius: 4px;
   }

   .script-container::-webkit-scrollbar-thumb {
      background: #4a5568;
      border-radius: 4px;
   }

   .script-container::-webkit-scrollbar-thumb:hover {
      background: #667eea;
   }

   .script-code {
      font-family: 'Fira Code', 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
      font-size: 12px;
      color: #e2e8f0;
      white-space: pre-wrap;
      word-break: break-all;
      margin: 0;
      line-height: 1.6;
      tab-size: 2;
   }

   .copy-script-btn {
      position: absolute;
      top: 4px;
      right: 8px;
      padding: 6px 12px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      border: none;
      border-radius: 6px;
      cursor: pointer;
      font-size: 12px;
      font-weight: 500;
      display: flex;
      align-items: center;
      gap: 6px;
      transition: all 0.2s ease;
      z-index: 10;
   }

   .copy-script-btn:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
   }

   .copy-script-btn:active {
      transform: translateY(0);
   }
`;

export const Loader = styled.span`
   width: 68px;
   height: 68px;
   border: 5px solid #9ca3af;
   border-bottom-color: #673AB7;
   border-radius: 50%;
   display: block;
   box-sizing: border-box;
   animation: rotation 1s linear infinite;
   margin: 0 auto;

   @keyframes rotation {
      0% {
         transform: rotate(0deg);
      }
      100% {
         transform: rotate(360deg);
      }
   }
`;